import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { ExperimentService } from '@services/experiment/experiment.service';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'app-key-technologies-banner',
  templateUrl: './key-technologies-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyTechnologiesBannerComponent {
  private readonly conn = inject(ConnectionService);
  private readonly experimentService = inject(ExperimentService);
  private readonly eventLogger = inject(EventLoggerService);

  regimenClass = input.required<string>();

  readonly keyTechnologiesImage = signal<string | null>(null);

  constructor() {
    effect((): void => {
      const regimenClass = this.regimenClass();
      this.keyTechnologiesImage.set(null);
      if (!this.experimentService.showKeyTechnologiesBannerOnRegimen || !regimenClass) return;
      void this.loadKeyTechnologiesImage(regimenClass);
    });
  }

  private async loadKeyTechnologiesImage(regimenClass: string): Promise<void> {
    const timeline = await this.conn.getImprovementTimeline(regimenClass);
    if (this.regimenClass() !== regimenClass) return;
    if (timeline?.keyTechnologiesImage) {
      this.keyTechnologiesImage.set(timeline.keyTechnologiesImage);
      this.eventLogger.cleverTapEvent('impression', JSON.stringify({
        name: 'key_technologies_banner_shown',
        placement: 'REGIMEN',
        class: regimenClass,
      }));
    }
  }
}
